<template>
  <div class="passwordCheck">
    <mu-flexbox align="baseline">
      <mu-flexbox-item>
        <div class="pw-rules">
          <img src="../../../static/pw/tick_active" alt="" v-if="passwordCheck.upper === true">
          <img src="../../../static/pw/tick_inactive" alt="" v-if="passwordCheck.upper === false">
          <img src="../../../static/pw/tick_error" alt="" v-if="passwordCheck.upper === 'error'">
          <span :class="{active: passwordCheck.upper === true, error: passwordCheck.upper === 'error'}">At least one <strong>upper case letter (A-Z)</strong></span>
        </div>
        <div class="pw-rules">
          <img src="../../../static/pw/tick_active" alt="" v-if="passwordCheck.lower === true">
          <img src="../../../static/pw/tick_inactive" alt="" v-if="passwordCheck.lower === false">
          <img src="../../../static/pw/tick_error" alt="" v-if="passwordCheck.lower === 'error'">
          <span :class="{active: passwordCheck.lower === true, error: passwordCheck.lower === 'error'}">At least one <strong>lower case letter (a-z)</strong></span>
        </div>
        <div class="pw-rules">
          <img src="../../../static/pw/tick_active" alt="" v-if="passwordCheck.number === true">
          <img src="../../../static/pw/tick_inactive" alt="" v-if="passwordCheck.number === false">
          <img src="../../../static/pw/tick_error" alt="" v-if="passwordCheck.number === 'error'">
          <span :class="{active: passwordCheck.number === true, error: passwordCheck.number === 'error'}">At least one <strong>number</strong> (0-9)</span>
        </div>
      </mu-flexbox-item>
      <mu-flexbox-item>
        <div class="pw-rules">
          <img src="../../../static/pw/tick_active" alt="" v-if="passwordCheck.special === true">
          <img src="../../../static/pw/tick_inactive" alt="" v-if="passwordCheck.special === false">
          <img src="../../../static/pw/tick_error" alt="" v-if="passwordCheck.special === 'error'">
          <span :class="{active: passwordCheck.special === true, error: passwordCheck.special === 'error'}"><strong>1 special character</strong>, e.g. <strong>#?!@$%^&*</strong></span>
        </div>
        <div class="pw-rules">
          <img src="../../../static/pw/tick_active" alt="" v-if="passwordCheck.length === true">
          <img src="../../../static/pw/tick_inactive" alt="" v-if="passwordCheck.length === false">
          <img src="../../../static/pw/tick_error" alt="" v-if="passwordCheck.length === 'error'">
          <span :class="{active: passwordCheck.length === true, error: passwordCheck.length === 'error'}"><strong>10+ characters</strong> in length</span>
        </div>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>

<script>
    export default {
        name: "PasswordStrengthValidation.vue",
        props: {
          password: {
            type: String,
            default:() => null
          }
        },
        data() {
          return {
            passwordCheck: {
              upper: false,
              lower: false,
              number: false,
              special: false,
              length: false,
            }
          }
        },
        watch: {
          'password': function () {
            let self = this;
            let pw = this.password;
            self.passwordCheck.upper = RegExp('(?=.*?[A-Z])').test(pw);
            if (self.passwordCheck.upper === false) {
              self.passwordCheck.upper = 'error';
            }
            self.passwordCheck.lower = RegExp('(?=.*?[a-z])').test(pw);
            if (self.passwordCheck.lower === false) {
              self.passwordCheck.lower = 'error';
            }
            self.passwordCheck.number = RegExp('(?=.*?[0-9])').test(pw);
            if (self.passwordCheck.number === false) {
              self.passwordCheck.number = 'error';
            }
            self.passwordCheck.length = RegExp('.{10,}').test(pw);
            if (self.passwordCheck.length === false) {
              self.passwordCheck.length = 'error';
            }
            self.passwordCheck.special = RegExp('(?=.*?[#?!@$%^&*-])').test(pw);
            if (self.passwordCheck.special === false) {
              self.passwordCheck.special = 'error';
            }
          },
        },
    }

</script>

<style lang="less">
  .passwordCheck {
    margin: 0 0 10px;
    padding: 0 5px;
    .pw-rules {
      margin: 15px 0;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
      span {
        vertical-align: middle;
        font-size: 1em;
        line-height: 1.5;
        color: #000;
        font-family: 'Poppins', Arial, sans-serif;
        &.active {
          opacity: 0.3;
        }
        &.error {
          color: #d9140d;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PasswordStrengthValidation.vue?53b54615